import { RoutePath } from "@src/interfaces";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

interface MenuItem {
  title: string;
  titleClassName?: string;
  location: RoutePath;
  icon: JSX.Element;
  onClick: () => void;
}

export const DropdownMenu = ({
  menuItems,
  isShown,
  onClose,
}: {
  menuItems: Record<string, MenuItem[]>;
  isShown?: boolean;
  onClose: () => void;
}) => {
  const location = useLocation();
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isShown) return;

    const handleOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleOutside);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
    };
  }, [isShown, onClose]);

  const entries = Object.entries(menuItems) as [string, MenuItem[]][];

  return (
    <div
      ref={wrapperRef}
      className={`absolute right-0 top-7 w-[200px] flex flex-col gap-2 py-2 bg-background_primary rounded-xl z-[9999] shadow-md border-[1px] border-background_secondary/5 transition-all duration-200 overflow-hidden opacity-0 ${
        isShown ? "opacity-100" : ""
      }`}
    >
      {entries.map(([sectionName, items], i) => {
        return (
          <div className="flex flex-col gap-2 w-full" key={sectionName}>
            <>
              {items.map(
                (item, i) =>
                  location.pathname !== item.location && (
                    <div
                      className="cursor-pointer py-2 px-4 flex items-center gap-2 hover:bg-bg_text_primary/10"
                      onClick={item.onClick}
                      key={item.title + i}
                    >
                      {item.icon}
                      <p
                        className={`text-text_primary font-medium ${
                          item.titleClassName || ""
                        }`}
                      >
                        {item.title}
                      </p>
                    </div>
                  ),
              )}
              {i < entries.length - 1 && (
                <div className="w-full h-[1px] bg-bg_text_primary/10" />
              )}
            </>
          </div>
        );
      })}
    </div>
  );
};
